import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MdsConfig } from '@maersk-global/mds-config';
// Auto-starts button-click tracking for the current document (native buttons,
// input[type=button/submit/reset], and mc-button elements) and pushes events
// to window.dataLayer / GTM. See @maersk-global/orbit-analytics-gtm README for
// custom payloads, opting non-button elements in via data-orbit-track, etc.
import '@maersk-global/orbit-analytics-gtm';

import { AppModule } from './app/app.module';
import { RumInit } from '@maersk-global/telemetry-web-sdk';
import { environment } from './environments/environment';

// MDS icons load their SVG data dynamically at runtime, not as bundled assets.
// Without this, mc-icon (and icon/trailingicon props on other MDS components)
// silently render nothing - no console error, no build error, just no icon.
// Must be set before bootstrapModule() actually creates component instances below.
MdsConfig.forceIconsCdnBundle = true;

// orbit-analytics-gtm looks for GTM/dataLayer config on a global runtime object
// (window.environment.orbitAnalytics) - Angular's environment.ts import is a
// private module-level constant, never exposed on window automatically, so we
// expose it ourselves here. Explicit gtmId is set per-environment in
// environment.ts/-test/-prod rather than relying on the library's env-name
// auto-detection, since this app's "test" environment name doesn't match any
// key in the library's own managed-GTM-ID table.
(window as any).environment = environment;

const appName = environment.rumConfig.appName;
const apiKey = environment.rumConfig.apiKey;
const env = environment.rumConfig.appName.split('-')[1];
RumInit({
  app: {
    environment: env,
    name: appName,
    version: '1.0.0'
  },
  apiKey: apiKey,
  debug: false,
  traceLog: true,
  useSendBeacon: true,
  propagateTraceHeaderCorsUrls: [/https?:\/\/.*/]
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
